const SoundEffects = Object.freeze({
  none: "none",
  chime: "chime",
  ringing: "ringing",
  knock: "knock",
});

export default SoundEffects;
